import React from 'react'

const Home = () => {
  return (
    <div>Nakshatra Weekly:  Astro Refs</div>
  )
}

export default Home